<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca utenti"
    results-title="Utenti"
    no-results-message="Nessun utente trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <user-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: 'User', params: { id: r.id } }">
          <div slot="header" class="font-weight-bold">
            {{ r.username }} <tag-list :value="tagsFor(r)" />
          </div>
          <div>
            <info-field labelClass="col" label="Cognome">
              {{ r.lastName }}
            </info-field>
            <info-field labelClass="col" label="Nome">
              {{ r.firstName }}
            </info-field>
            <info-field labelClass="col" label="E-mail">
              {{ r.email }}
            </info-field>
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'User', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import UserService from 'app/services/UserService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = UserService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Utenti'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Username',
          path: 'username'
        },
        {
          label: 'Nome',
          path: 'firstName'
        },
        {
          label: 'Cognome',
          path: 'lastName'
        },
      ];
    }
  },

  methods: {
    tagsFor(result) {
      return result.workgroups.map(item => {
        const text = item.workgroup.name;
        let variant, help;
        if (item.type === 'ADMINISTRATOR') {
          variant = 'primary';
          help = `${result.displayName} è amministratore del gruppo ${item.workgroup.name}`;
        } else if (item.type === 'ORDINARY') {
          variant = 'success';
          help = `${result.displayName} è utente ordinario del gruppo ${item.workgroup.name}`;
        } else if (item.type === 'GUEST') {
          variant = 'warning';
          help = `${result.displayName} è ospite del gruppo ${item.workgroup.name}`;
        }
        return { text, variant, help };
      });
    }
  }
}
</script>
